import React from 'react';
import runrunner from '../../assets/img/games/runrunner.jpeg'
import twoflags from '../../assets/img/games/twoflags.jpeg'
import thelosttreasure from '../../assets/img/games/thelosttreasure.jpeg'
import retrosnake from '../../assets/img/games/RetroSnake.jpeg'
import JuegoComponent from '../../components/Juego.component';

const JuegosLayout = () => {
    return (
        <section className='topic'>
            <h2 id="games"><a href="#games">#</a>Juegos</h2>
            <JuegoComponent 
                img={retrosnake} 
                altImg='retrosnake' 
                titulo='N04 - The Retro Snake'
                descripcion={<>
                    <p>Recordemos un clásico juego de nuestra infancia...</p>
                    <p>Queremos recordar un juego clásico de un teléfono clásico como NOKIA, una verdadera revolución para esos días... The Snake</p>                    
                </>}
                linkApple='https://apps.apple.com/cl/app/n04-retro-snake/id6475216053'
                linkGoogle='https://play.google.com/store/apps/details?id=cl.novandigames.retrosnake'
            />
            <JuegoComponent 
                img={thelosttreasure} 
                altImg='thelosttreasure' 
                titulo='The Lost Treasure'
                descripcion={
                    <p>Hace mucho tiempo, los antiguos piratas españoles perdieron una gran fortuna en joyas y monedas de oro. Este tesoro estuvo perdido durante años, pero ahora se han encontrado mapas con su ubicación. La pregunta ahora es, ¿eres tú quien podría encontrar EL TESORO PERDIDO?</p>
                }
                linkApple='https://apps.apple.com/cl/app/find-the-lost-treasure/id1659278754'
                linkGoogle='https://play.google.com/store/apps/details?id=cl.novandi.thelosttreasure'
            />
            <JuegoComponent 
                img={twoflags} 
                altImg='twoflags' 
                titulo='Two Flags'
                descripcion={<>
                    <p>En este universo, hay dos tipos de banderas, Cuadradas y Triangulares. Solo debes tomar las Banderas Cuadradas para poder avanzar hasta el infinito, no las dejes pasar.</p>
                    <p>Ojo, las banderas triangulares no son tan inofensivas como parecen...</p>
                </>}
                linkApple='https://apps.apple.com/cl/app/two-flags/id1633913725'
                linkGoogle='https://play.google.com/store/apps/details?id=cl.novandi.twoflags'
            />
            <JuegoComponent 
                img={runrunner} 
                altImg='runrunner' 
                titulo='Run Runner'
                descripcion={<>
                    <p>Los RUN RUNNER son unos personajes que viven en una dimension paralela y su objetivo es solo correr. Hoy están buscando a la persona con mas habilidad y con mejor coordinación mano-ojo para que les ayude a pasar los obstáculos que se presentan en sus lineas.</p>
                    <p>Cada obstáculo pasado es un punto ganado, ayudalos a pasar la mayor cantidad de obstáculos que puedas...</p>
                    <p>Ahora solo nos queda una pregunta por responder... ¿Cuántos puntos crees que puedes obtener?.</p>
                </>}
                linkApple='https://apps.apple.com/cl/app/run-runner/id1627924417'
                linkGoogle='https://play.google.com/store/apps/details?id=cl.novandi.runrunner'
            />
        </section>
    );
};

export default JuegosLayout;

